import { DecoratorNode } from "lexical";

export const $createImageNode = ({
  altText,
  height,
  maxWidth = 400,
  src,
  width,
}) => {
  return new ImageNode({ altText, height, maxWidth, src, width });
};

const convertImageElement = (domNode) => {
  if (domNode instanceof HTMLImageElement) {
    const { src, alt } = domNode;
    const node = $createImageNode({ src, altText: alt });
    return { node };
  }
  return null;
};

export class ImageNode extends DecoratorNode {
  __src;
  __altText;
  __height;
  __width;
  __maxWidth;

  constructor({ src, altText, height, width, maxWidth, key }) {
    super(key);
    this.__src = src;
    this.__altText = altText;
    this.__height = height;
    this.__width = width;
    this.__maxWidth = maxWidth;
  }

  static getType() {
    return "image";
  }

  static clone(_node) {
    return new ImageNode({
      altText: _node.__altText,
      src: _node.__src,
      height: _node.__height,
      width: _node.__width,
      maxWidth: _node.__maxWidth,
      key: _node.getKey(),
    });
  }

  decorate() {
    return (
      <img
        src={this.__src}
        alt={this.__altText}
        style={{
          height: this.__height,
          width: this.__width,
          maxWidth: this.__maxWidth,
        }}
      />
    );
  }

  createDOM() {
    const span = document.createElement("span");
    return span;
  }

  updateDOM() {
    return false;
  }

  exportDOM() {
    const image = document.createElement("img");
    image.setAttribute("src", this.__src);
    image.setAttribute("alt", this.__altText);
    return { element: image };
  }

  static importDOM() {
    return {
      img: () => {
        return { conversion: convertImageElement, priority: 0 };
      },
    };
  }

  static importJSON(serializedNode) {
    return new ImageNode({
      src: serializedNode.src,
      altText: serializedNode.altText,
    });
  }

  exportJSON() {
    return {
      type: "image",
      version: 1,
      src: this.__src,
      altText: this.__altText,
      height: this.__height,
      width: this.__width,
      maxWidth: this.__maxWidth,
    };
  }
}
